export default __webpack_public_path__ + "static/media/about1.5a437bf7.jpeg";